<template>
  <v-card class="sor-item-detail" v-if="item">
    <v-card-title class="justify-center">
      <span class="mr-8">
        <b>Item No: </b>
        {{
          item.item_group.sub_sub_section.sub_section.section.order_no
            .toString()
            .padStart(2, "0")
        }}{{ item.item_group.item_prefix
        }}{{ item.category ? item.category.suffix : "A" }}
      </span>
      <v-spacer></v-spacer>
      <v-btn
        class="mr-2"
        :disabled="
          !item.item_group.sub_sub_section.sub_section.section
            .special_conditions
        "
        @click="showSpecialConditionsPdf"
        >Special Conditions
      </v-btn>
      <v-btn class="mr-2" @click="showRelatedPdf">SOR Booklet </v-btn>
      <v-btn color="primary" v-if="itemIndex" @click="onAddClick"> Add </v-btn>
      <v-btn icon @click="onClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text
      class="d-flex flex-column flex-grow-1 overflow-y-auto sor-item-detail-content"
    >
      <v-divider></v-divider>
      <div class="info-header-row">
        <div class="info-header">
          <v-row v-if="workOrder">
            <v-col cols="4" md="2">Contract Number:</v-col>
            <v-col cols="8" md="10">{{ workOrder.contract.id }}</v-col>
          </v-row>
          <v-row v-if="workOrder">
            <v-col cols="4" md="2">Contract Year:</v-col>
            <v-col cols="8" md="10">{{ workOrder.contract_year.year }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4" md="2">SoR Edition:</v-col>
            <v-col cols="8" md="10">{{
              workOrder ? workOrder.contract.sor.name : sorName
            }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4" md="2">Volume:</v-col>
            <v-col cols="8" md="10">{{
              item.item_group.sub_sub_section.sub_section.section.volume.name
            }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4" md="2">Section:</v-col>
            <v-col cols="8" md="10">{{
              item.item_group.sub_sub_section.sub_section.section.order_no
            }}</v-col>
          </v-row>
        </div>
        <div class="item-price-wrapper">
          <v-row>
            <v-col cols="4" class="font-weight-bold text-right">Unit:</v-col>
            <v-col cols="8">{{ processedUnit }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="font-weight-bold text-right"
              >SoR Rate:</v-col
            >
            <v-col cols="8">{{ $parseCurrency(item.value) }}</v-col>
          </v-row>
          <v-row v-if="workOrder">
            <v-col cols="4" class="font-weight-bold text-right"
              >Contract Percentage:</v-col
            >
            <v-col cols="8">{{ contractPercentage }}%</v-col>
          </v-row>
        </div>
      </div>
      <div class="item-info-row">
        <div class="item-description-wrapper">
          <div class="item-description-title">Item descriptions:</div>
          <div
            class="item-description-description"
            v-html="item.item_group.sub_sub_section.sub_section.name"
          ></div>
          <div
            class="item-description-description"
            v-html="
              replaceItemNo(item, item.item_group.sub_sub_section.descriptions)
            "
          ></div>
          <div
            class="item-description-description"
            v-html="
              replaceItemNo(
                item,
                item.item_group.sub_sub_section.sub_section.descriptions
              )
            "
          ></div>
          <div
            class="item-description-remarks"
            v-html="
              replaceItemNo(
                item,
                item.item_group.full_description ||
                  item.item_group.printed_description
              )
            "
          ></div>
        </div>
      </div>
      <v-row class="item-info-category flex-grow-0" v-if="item.category">
        <v-icon>mdi-menu-right</v-icon>
        <v-col
          cols="11"
          v-html="JSON.parse(item.category.definition).join('; ')"
        >
        </v-col>
      </v-row>
      <div class="item-related-items-row" v-if="item.related_items.length > 0">
        <v-divider class="mb-4"></v-divider>
        <div class="item-related-items-title">Related Items</div>
        <v-data-table
          :headers="relatedItemHeaders"
          :items="item.related_items"
          hide-default-footer
          :items-per-page="1000"
          class="item-related-items-table"
        >
          <template #item.item_no="{ item }">
            {{
              item.item_group.sub_sub_section.sub_section.section.order_no
                .toString()
                .padStart(2, "0")
            }}{{ item.item_group.item_prefix
            }}{{ item.category ? item.category.suffix : "A" }}
          </template>
          <template #item.descriptions="{ item, index }">
            <v-container
              fluid
              class="px-0 item-related-items-table-descriptions"
            >
              <v-row no-gutters>
                <v-col cols="11">
                  <v-row no-gutters>
                    <v-col cols="12" class="font-weight-bold">
                      S{{
                        item.item_group.sub_sub_section.sub_section.section.order_no
                          .toString()
                          .padStart(2, "0")
                      }}
                      {{
                        item.item_group.sub_sub_section.sub_section.section.name
                      }}
                    </v-col>
                    <v-col
                      cols="12"
                      v-html="
                        replaceItemNo(
                          item,
                          item.item_group.sub_sub_section.sub_section
                            .descriptions
                        )
                      "
                    ></v-col>
                    <v-col
                      cols="12"
                      v-html="
                        replaceItemNo(
                          item,
                          item.item_group.full_description ||
                            item.item_group.printed_description
                        )
                      "
                    ></v-col>
                    <v-col cols="12" v-if="item.category">
                      {{ JSON.parse(item.category.definition).join("; ") }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="1" class="align-self-center">
                  <v-btn
                    icon
                    color="primary"
                    @click="showRelatedItemDetail(item)"
                  >
                    <v-icon large>mdi-information-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template #item.unit="{ item }">
            {{ $processedUnit(item.item_group.sub_sub_section.unit) }}
          </template>
          <template #item.value="{ item }">
            {{ $parseCurrency(item.value) }}
          </template>
          <template #item.actions="{ item, index }">
            <v-btn
              color="primary"
              text
              @click="onRelatedItemAddClicked(item, index)"
            >
              Add
            </v-btn>
          </template>
        </v-data-table>
      </div>
      <div class="item-remarks-row" v-if="item.remarks.length > 0">
        <v-divider class="mb-4"></v-divider>
        <div class="item-remarks-title">Remarks</div>
        <ul class="item-remarks-list">
          <li v-for="remark in item.remarks" :key="remark.id">
            <div class="d-flex">
              {{
                replaceItemNo(
                  item,
                  remark.item_remark_group.printed_description
                )
              }}
              <v-spacer></v-spacer>
              <b>{{ remark.value }}</b>
            </div>
          </li>
        </ul>
      </div>
      <div
        class="flex-grow-0"
        v-if="item.item_group.printed_remarks"
        v-html="replaceItemNo(item, item.item_group.printed_remarks)"
      ></div>
      <!--      <v-row class="item-description-remarks flex-grow-0"-->
      <!--             v-if="item.item_group.printed_remarks">-->
      <!--        <v-icon>mdi-menu-right</v-icon>-->
      <!--        <v-col cols="11" v-html="replaceItemNo(item, item.item_group.printed_remarks)"></v-col>-->
      <!--      </v-row>-->
    </v-card-text>
    <v-card-actions v-if="itemIndex">
      <v-spacer></v-spacer>
      <v-btn @click="prevItem" :disabled="currentIndex === 1">
        &lt;&lt; Previous Result
      </v-btn>
      <v-btn @click="nextItem" :disabled="currentIndex === itemCount">
        Next Result &gt;&gt;
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import SorItemDetailDialog from "@/components/sor/SorItemDetailDialog";

export default {
  name: "SorRelatedItemDetailDialog",
  components: {},
  props: {
    workOrder: Object,
    sorName: String,

    itemId: String,
    queryParams: Object,
    itemIndex: Number,
  },
  setup(props, { root, emit }) {
    const onClose = function () {
      // if (confirm('Confirm Closing Window?')) {
      root.$emit("submit", undefined);
      // }
    };

    const item = ref(null);
    const itemCount = ref(1);
    const currentIndex = ref(props.itemIndex);
    const getItem = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/sor/items/",
        params: {
          ...props.queryParams,
          page_size: 1,
          page_no: currentIndex.value,
        },
      });

      if (response.body.success) {
        item.value = response.body.items[0];
        itemCount.value = response.body.count;
      }
    };
    const prevItem = function () {
      currentIndex.value = Math.max(currentIndex.value - 1, 1);
      getItem();
    };
    const nextItem = function () {
      currentIndex.value = Math.min(currentIndex.value + 1, itemCount.value);
      getItem();
    };

    const contractPercentage = computed(() => {
      if (props.workOrder && item.value) {
        const map = JSON.parse(props.workOrder.contract_year.percentages);

        return (
          (map[
            item.value.item_group.sub_sub_section.sub_section.section.order_no.toString()
          ] || 100) - 100
        ).toFixed(2);
      } else {
        return "";
      }
    });
    const processedUnit = computed(() => {
      if (item.value) {
        return root.$processedUnit(item.value.item_group.sub_sub_section.unit);
      }
      return null;
    });
    const replaceItemNo = function (item, str) {
      return str.replaceAll(/({{[0-9]+}})/g, (match) => {
        let withoutBrackets = match.replace("{{", "").replace("}}", "");

        return `${item.item_group.sub_sub_section.sub_section.section.order_no
          .toString()
          .padStart(2, "0")}${withoutBrackets.padStart(3, "0")}`;
      });
    };

    const showSpecialConditionsPdf = function () {
      root.$showPdf(
        `/api/file/${item.value.item_group.sub_sub_section.sub_section.section.special_conditions}`
      );
    };
    const showRelatedPdf = function () {
      root.$showPdf(
        `/api/file/${item.value.related_pdf}`,
        item.value.related_pdf_page
      );
      //
      // window.open(`api/file/${item.value.related_pdf}`, '_blank')
    };
    const onAddClick = function () {
      emit("submit", item.value);
    };

    const relatedItemHeaders = ref([
      {
        text: root.$t("item.item_no"),
        value: "item_no",
        width: 150,
        sortable: false,
      },
      {
        text: root.$t("item.descriptions"),
        value: "descriptions",
        sortable: false,
      },
      {
        text: root.$t("item.unit"),
        value: "unit",
        width: 100,
        sortable: false,
      },
      {
        text: root.$t("item.rate"),
        value: "value",
        width: 100,
        sortable: false,
      },
      { text: "", value: "actions", sortable: false, width: 50 },
    ]);
    const onRelatedItemAddClicked = function (item) {
      emit("submit", item);
    };
    const showRelatedItemDetail = async function (item) {
      const addedItem = await root.$dialog.showAndWait(SorItemDetailDialog, {
        persistent: true,
        width: "90vw",

        workOrder: props.workOrder,

        queryParams: {
          ...props.queryParams,
          filters: { id: { exact: true, value: item.id } },
        },
        sorName: props.sorName,
      });

      if (addedItem) {
        emit("submit", addedItem);
      }
    };

    const numberWithCommas = function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    onMounted(() => {
      getItem();
    });

    return {
      onClose,

      item,
      itemCount,
      currentIndex,

      prevItem,
      nextItem,

      contractPercentage,
      processedUnit,
      replaceItemNo,

      showSpecialConditionsPdf,
      showRelatedPdf,
      onAddClick,

      relatedItemHeaders,
      onRelatedItemAddClicked,
      showRelatedItemDetail,

      numberWithCommas,
    };
  },
};
</script>

<style lang="less">
.sor-item-detail {
  display: flex;
  flex-direction: column;
  height: 90vh;
  color: black;

  .sor-item-detail-content {
    color: black !important;
  }

  .info-header-row {
    flex: 0 0 auto;
    margin: 16px 0;

    display: flex;
    gap: 16px;

    .info-header {
      width: 70%;

      border-radius: 8px;
      padding: 16px 24px;

      font-size: 116.66%;
      color: #000;
    }

    .item-price-wrapper {
      flex: 1 1 320px;
      padding: 16px;
      font-size: 116.66%;
    }
  }

  .item-info-row {
    flex: 0 0 auto;
    width: 70%;

    display: flex;
    gap: 32px;
    align-items: center;

    .item-description-wrapper {
      flex: 1 1 0;

      table {
        font-size: 100%;
        border-collapse: collapse;

        td {
          border: solid 1px black;
          padding: 1px;
        }
      }

      .item-description-title {
        font-weight: bold;
        font-size: 116.66%;
        color: black;
        margin-bottom: 8px;
      }

      .item-description-description {
        color: black;
        margin-bottom: 8px;
      }

      .item-description-remarks {
        color: black;
        margin: 8px 0;
      }
    }
  }

  .item-info-category {
    color: black;
    margin: 8px 0;
    font-size: 115%;
    font-weight: bold;
  }

  .item-related-items-row {
    flex: 0 0 auto;
    margin: 16px 0;

    display: flex;
    flex-direction: column;

    .item-related-items-title {
      font-weight: bold;
      font-size: 116.66%;
      color: black;
      margin-bottom: 8px;
    }

    .item-related-items-table-descriptions {
      table {
        font-size: 100%;
        border-collapse: collapse;

        td {
          border: solid 1px black;
          padding: 1px;
        }
      }
    }
  }

  .item-remarks-row {
    flex: 0 0 auto;
    margin: 16px 0;

    display: flex;
    flex-direction: column;

    .item-remarks-title {
      font-weight: bold;
      font-size: 116.66%;
      color: black;
      margin-bottom: 8px;
    }
  }
}
</style>
